import { render, staticRenderFns } from "./TabChangeHistory.vue?vue&type=template&id=b6b5f8c2&"
import script from "./TabChangeHistory.vue?vue&type=script&lang=js&"
export * from "./TabChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports